import { Timestamp } from "firebase/firestore";
import Transaction from "../models/Transaction";

export const getTransactionsOverTime = (transactions: Transaction[], start: Date, end: Date): Transaction[] => {
    const new_transactions: Transaction[] = [];
    transactions.forEach((transaction) => {
        const date = transaction.date.toDate();
        if(transaction.recurrance) {
            const currDate = new Date(date);
            while (currDate < end) {
                if(currDate > start) {
                    const nt = {...transaction};
                    nt.date = Timestamp.fromDate(currDate);
                    new_transactions.push(nt);
                }
                switch(transaction.recurrance.type) {
                    case "days":
                        currDate.setDate(currDate.getDate() + transaction.recurrance.value);
                        break;
                    case "weeks":
                        currDate.setDate(currDate.getDate() + 7 * transaction.recurrance.value);
                        break;
                    case "months":
                        currDate.setMonth(currDate.getMonth() + transaction.recurrance.value);
                        break;
                    case "years":
                        currDate.setFullYear(currDate.getFullYear() + transaction.recurrance.value);
                        break;
                }
            }
        }
    });
    return new_transactions;
}